// PhonePresence -- "who's on the phone" chips in the masthead.
//
// Loads GET /api/calls/presence once, then follows live 'presence'
// events that CallPopup receives on its stream and re-broadcasts as a
// window event (one stream per tab, not two). Shows each monitored
// extension that is ringing, dialling or on a call, with who's on the
// other end and a running timer. Nothing renders when the office is quiet.

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function clock(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  return m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}:${String(s % 60).padStart(2, '0')}`;
}

function recordPath(p) {
  if (!p.contact_id) return null;
  if (p.record_type === 'customer') return `/customers/${p.contact_id}`;
  if (p.record_type === 'lead') return `/leads/${p.contact_id}`;
  if (p.record_type === 'strategic_account') return `/strategic-accounts/${p.contact_id}`;
  if (p.record_type === 'vendor_contact') return `/vendor-contacts/${p.contact_id}`;
  if (p.record_type === 'distributor') return `/distributors/${p.contact_id}`;
  return null;
}

const LABEL = { on_call: 'on call with', ringing: 'ringing:', dialing: 'calling' };

export default function PhonePresence() {
  const [list, setList] = useState([]);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let cancelled = false;
    axios.get('/api/calls/presence')
      .then((r) => { if (!cancelled) setList(r.data.presence || []); })
      .catch(() => {});
    const onPresence = (e) => setList(Array.isArray(e.detail) ? e.detail : []);
    window.addEventListener('xsite-presence', onPresence);
    return () => { cancelled = true; window.removeEventListener('xsite-presence', onPresence); };
  }, []);

  useEffect(() => {
    if (!list.length) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [list.length]);

  if (!list.length) return null;

  return (
    <span className="phone-presence" aria-label="Who's on the phone">
      {list.map((p) => {
        const path = recordPath(p);
        const first = String(p.name || '').split(' ')[0];
        return (
          <span key={p.ext} className={`phone-presence-chip is-${p.status}`} title={`Ext ${p.ext}`}>
            <span className="phone-presence-dot" />
            <strong>{first}</strong>&nbsp;{LABEL[p.status] || ''}&nbsp;
            {path ? <Link to={path}>{p.party}</Link> : <span>{p.party}</span>}
            {p.status === 'on_call' && <span className="phone-presence-time">{clock(now - new Date(p.since).getTime())}</span>}
          </span>
        );
      })}
    </span>
  );
}
